import React from "react";
import { Doughnut } from "react-chartjs-2";
import "../style/Sup/SupDashboard.css";
class GraficoDonut extends React.Component {
  constructor(props) {
    super(props);
    this.update = false;
    this.state = {
      dataGrafic: [],
    };
  }

  getOptions() {
    return {
      maintainAspectRatio: false,
      responsive: true,

      title: {
        display: false,
      },
      elements: {
        line: {
          fill: false,
        },
      },
      legend: {
        display: false,
        position: "bottom",
        labels: {
          usePointStyle: true,
          fontColor: "#000",
          fontSize: 26,
          fontStyle: "bold",
        },
      },
      hover: {
        mode: "index",
        intersect: false,
      },
      plugins: {
        datalabels: {
          display: false,
          clamp: true,
          align: (context) => {
            if (context.dataset.type == "line") {
              return "center";
            } else if (context.dataset.type == "bar") {
              return "end";
            }
          },
          backgroundColor: (context) => {
            const index = context.dataIndex;
            const value = context.dataset.data[index];
            return value > 0
              ? context.dataset.pointBorderColor
              : "rgba(0, 0, 0, 0)";
          },
          borderRadius: (context) => {
            return context.active ? 0 : 32;
          },
          borderWidth: 1,
          color: "rgba(0,0,0)",
          font: {
            size: 10,
            weight: 500,
            style: "bold",
          },
          offset: 8,
          formatter: (value, context) => {
            const i = context.dataIndex;
            const prev = context.dataset.data[i - 1];
            const diff = prev !== undefined ? prev - value : 0;
            const glyph = diff < 0 ? "\u25B2" : diff > 0 ? "\u25BC" : "\u25C6";
            return value > 0
              ? context.active
                ? glyph + " " + value
                : value
              : "";
          },
        },
      },
    };
  }

  chartData() {
    return {
      labels: this.props.labels,
      datasets: this.props.data,
    };
  }

  render() {
    return (
      <Doughnut
        ref="chartDonut"
        data={this.chartData()}
        options={this.getOptions()}
      />
    );
  }
}
export default GraficoDonut;



// WEBPACK FOOTER //
// ./src/componentes/GraficoDonut.jsx